import {Avatar} from 'antd'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import React from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault} from 'views/Shared'
import {paths} from '../../MainPage/contains'
import _ from "lodash";
import categoryIcons from "../../../conts/categoryIcons";

const renderCategoryLink = (item, index) => {
    const { name, avatar, language, alt_idname } = item
    const id = getId(item)
    const pathname = paths.categoryPath
        .replace(':category', id)

    const Icon = _.get(categoryIcons, item.idname, categoryIcons["default"] )

    return (
        <Link
            key={index}
            to={{
                pathname,
                search: ``,
                state: { refId: alt_idname },
            }}
            className="w-fit text-color-000 hover:text-primary no-underline truncate">
            <div style={{padding: '5px 12px'}} className="flex flex-center gap-3 background-100 hover:bg-primary-50 rounded-md">
                <Icon size={20}/>
                <span className="font-medium pr-2">{name}</span>
            </div>
        </Link>
    )
}

export const renderCategoryItem =
  (onClick = NullAsDefault) =>
  (item, index) => {
    const { name, avatar, language, alt_idname } = item
    const id = getId(item)
    const pathname = paths.categoryPath
      .replace(':category', id)

    const avatarProps = {
      size: 24,
      shape: 'circle',
      className: 'bg-blue-500',
    }
    return (
      <Link
        key={index}
        to={{
          pathname,
          search: ``,
          state: { refId: alt_idname },
        }}
        onClick={onClick}
        className={classNames(
          'hover:border-primary hover:bg-primary hover:text-white',
          'no-underline m-1 border rounded-full truncate border-gray'
        )}>
        <div className="flex items-center justify-center md:p-2 p-1">
          {avatar ? (
            <Avatar
              {...avatarProps}
              src={avatar}
              alt={name}
            />
          ) : (
            <Avatar
              {...avatarProps}
              style={{ color: 'white' }}>
              {name.charAt(0)}
            </Avatar>
          )}
          <span className="md:px-3 px-1">{name}</span>
        </div>
      </Link>
    )
  }

export default renderCategoryLink
